import React, { lazy } from 'react'

const CopyrightRequestPage = lazy(() => import('./CopyrightDesk'))

export { CopyrightRequestPage }
